//This replaces Kiosks.js. Can safely remove Kiosks.js if this looks good.

import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import Add from "@mui/icons-material/Add";
import VisibilityIcon from "./Shared/VisibilityIcon";
import SyncIcon from "@mui/icons-material/Sync";

import AlertDialog from "../../../components/Dialogs/AlertDialog";
import DetailsDialog from "./Kiosks/DetailsDialog";
import ContainerLoading from "../../../components/Loading/ContainerLoading";

import { formatDate } from "../../../utils/misc";

import KioskRow from "./Kiosks/KioskRow";
import AddKioskLocationDialog from "./Kiosks/AddKioskLocationDialog";
import KioskListDialog from "./Kiosks/KiosksListDialog";
import KioskSetAllWorkflowDialog from "./Kiosks/KiosksSetAllWorkflowDialog";
import KioskEditDialog from "./Kiosks/KioskEditDialog";

import { KEY_NAME_REGEX } from "../../../constants";

import HttpContext from "../../../contexts/HTTP/HttpContext";

function Kiosks() {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  const [loading, setLoading] = useState(true);

  const [showCreateKeyDialog, setShowCreateKeyDialog] = useState(false);
  const [createKeyName, setCreateKeyName] = useState("");

  const [keyForTempDisplay, setKeyForTempDisplay] = useState("");

  const [showKiosksListDialog, setShowKiosksListDialog] = useState(false);
  const [kiosklistKiosk, setKiosklistKiosk] = useState(null);

  const [showKioskEditDialog, setShowKioskEditDialog] = useState(false);
  const [kioskEditTarget, setKioskEditTarget] = useState(null);
  const [kioskEditKiosk, setKioskEditKiosk] = useState(null);

  const [showSetAllWorkflowDialog, setShowSetAllWorkflowDialog] = useState(
    false
  );

  const [showFullSyncDialog, setShowFullSyncDialog] = useState(false);
  const [showCollectorSyncDialog, setShowCollectorSyncDialog] = useState(false);
  const [collectorSyncTarget, setCollectorSyncTarget] = useState({
    id: null,
    locationCode: null,
    technologyID: null
  });

  const [allWorkflowSubscription, setAllWorkflowSubscription] = useState(null);
  const [currentSubscriptionId, setCurrentSubscriptionId] = useState(null);

  const [showDisabledEntries, setShowDisabledEntries] = useState(false);

  const [allKeys, setAllKeys] = useState([]);
  const [numHiddenKeys, setNumHiddenKeys] = useState(0);

  const [currentSubscriptionData, setCurrentSubscriptionData] = useState(null);

  const [
    kioskListForceRefreshToggle,
    setKioskListForceRefreshToggle
  ] = useState(false);

  const { openSnackbar } = useSnackbar();

  //////////////////
  /// Kiosk List ///
  //////////////////
  const refreshKioskList = async () => {
    setLoading(true);

    const res2 = await get("/kiosk/getSubscriptionAdminKiosk");

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load kiosk data",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const kioskGroups = _.get(res2, "data");
      //console.log("[Kiosks.js] setAllKeys kioskGroups", kioskGroups);
      await setAllKeys(kioskGroups || []);
      if (kioskGroups) {
        setNumHiddenKeys(kioskGroups.filter(kg => kg.active == false).length);
      }
    }

    setLoading(false);
  };

  // const loadKeys = async () => {
  //   setLoading(true);

  //   const res2 = await get("/kiosk/getSubscriptionAdminKiosk");

  //   if (res2.status !== 200) {
  //     openSnackbar({
  //       open: true,
  //       message: "Unable to load kiosk data",
  //       variant: "alert",
  //       alert: {
  //         color: "error"
  //       },
  //       close: false
  //     });
  //   }

  //   if (res2.status == 403 || res2.status == 401) {
  //     //logout and redirect to login
  //     await get("/logout");
  //     localStorage.removeItem("accessToken");
  //     window.location.href = "/login";
  //   }

  //   if (res2.status === 200) {
  //     const kioskGroups = _.get(res2, "data");
  //     //console.log("[Kiosks.js] setAllKeys kioskGroups", kioskGroups);
  //     await setAllKeys(kioskGroups || []);
  //     if (kioskGroups) {
  //       setNumHiddenKeys(kioskGroups.filter(kg => kg.active == false).length);
  //     }

  //     //If there is a kiosk list already open, refresh teh displayed data. CUrrently doesn't work. i think something else is updating
  //     // if (currentSubscriptionId) {
  //     //   const newkiosklistKiosk = kioskGroups.find(
  //     //     item => item._id === currentSubscriptionId
  //     //   );
  //     //   console.log(
  //     //     "refreshing kiosklistKiosk newkiosklistKiosk",
  //     //     newkiosklistKiosk
  //     //   );

  //     //   await setKiosklistKiosk({ ...newkiosklistKiosk });
  //     // }

  //     //console.log(kioskGroups);
  //   }

  //   setLoading(false);
  // };

  //////////////////
  /// Kiosk Edit Functions ///
  //////////////////
  const handleSaveEditChanges = async payload => {
    //console.log("payload", payload);

    if (!payload) {
      openSnackbar({
        open: true,
        message: "Invalid payload.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    if (payload.locationCode == null) {
      openSnackbar({
        open: true,
        message: "Invalid Location Code. Please select a valid location code.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    const res2 = await post("/kiosk/editSubscription", payload);

    //console.log("res2.data", res2.data);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to save changes.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      setShowKioskEditDialog(false);
      return;
    }

    openSnackbar({
      open: true,
      message: "Changes saved successfully!",
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });
    setShowKioskEditDialog(false);
    await refreshKioskList();
  };

  const getSubscriptionById = async id => {
    //setLoading(true);

    const res2 = await get("/kiosk/getSubscriptionAdminKiosk/" + id);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load kiosk data",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const subscription = _.get(res2, "data");
      return subscription;
    }
  };

  const loadDetails = async id => {
    //Load details via id
    const res2 = await get("/kiosk/getSubscription/" + id);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");
      setCurrentSubscriptionData(subscriptionData);
      //console.log("loadDetails", subscriptionData);
    }
  };

  const handleActionViewKiosks = async id => {
    //Find list of kiosk for id

    const subscription = await getSubscriptionById(id);
    setKiosklistKiosk(subscription);
    console.log("[handleActionViewKiosks] subscription", subscription);
    //setKiosklistKiosk(allKeys.find(item => item._id === id));

    setCurrentSubscriptionId(id);
    setShowKiosksListDialog(true);
  };

  const refreshViewKiosksList = async () => {
    const subscription = await getSubscriptionById(currentSubscriptionId);
    setKiosklistKiosk(subscription);
  };

  const handleActionEdit = id => {
    const kiosk = allKeys.find(item => item._id === id);
    setKioskEditKiosk(kiosk);

    setKioskEditTarget(id);

    //console.log("handleActionEdit kiosk id", kiosk, id);

    setShowKioskEditDialog(true);
  };

  //////// Location Functions /////////

  const [locationOptions, setLocationOptions] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [locationsLoading, setLocationsLoading] = useState(false);

  const getDropLocations = async () => {
    setLocationsLoading(true);
    const res = await get("/kiosk/getDropLocations");

    console.log("allKeys", allKeys);

    let usedCodes = allKeys.map(i => i.locationCode);
    console.log("usedCodes", usedCodes);

    if (res.status !== 200) {
      setLocationsLoading(false);
      openSnackbar({
        open: true,
        message: "Unable to load Drop Locations.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    if (res.status === 200) {
      console.log("GOT 200 from getDropLocations res.data", res.data);

      //TODO: Check format of data
      setLocationOptions(res.data.dropLocations);

      let ll = res.data.dropLocations.map(location => location.code);
      console.log("ll", ll);

      let filteredCodes = ll.filter(i => !usedCodes.includes(i));
      console.log("filteredCodes", filteredCodes);

      //setLocationList(ll);
      setLocationList(filteredCodes);

      setLocationsLoading(false);
      openSnackbar({
        open: true,
        message: "Drop Locations Updated!",
        variant: "alert",
        alert: {
          color: "success"
        },
        close: false
      });
    }
  };

  //////// Workflow Functions /////////

  const handleSetWorkflowModeKiosk = async (
    subscriptionID,
    kioskID,
    kioskKeysID,
    newWorkflowMode
  ) => {
    // openSnackbar({
    //   open: true,
    //   message: "handleSetWorkflowModeKiosk commented out for testing",
    //   variant: "alert",
    //   alert: {
    //     color: "error"
    //   },
    //   close: false
    // });
    // return;

    //Now uses kioskKeyID to target.
    //TODO: Check and remove subscriptionID, might not be needed in 'postSetKioskKeyForADevice' anymore
    let payload = {
      subscriptionID: subscriptionID,
      kioskID: kioskID,
      kioskKeysID: kioskKeysID,
      newWorkflowMode: newWorkflowMode
    };

    const res2 = await post("/kiosk/updateWorkflow", payload);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      // TODO: Currently some issues with refreshing the KioskListDialog immediately, so force closing the dialog for now.
      //setShowKiosksListDialog(false);   //Testing a fix

      //console.log("[DEBUG] SANITY CHECK");

      //SInce format can change, just reload from server
      await refreshKioskList();

      //Lets just try updating just that view
      await refreshViewKiosksList();

      //Update modal
      await loadDetails(currentSubscriptionId);

      return subscriptionData;
    }
  };

  const handleSetWorkflowModeSubscription = async (
    subscriptionID,
    newWorkflowMode
  ) => {
    // openSnackbar({
    //   open: true,
    //   message: "handleSetWorkflowModeSubscription commented out for testing",
    //   variant: "alert",
    //   alert: {
    //     color: "error"
    //   },
    //   close: false
    // });
    // return;

    let payload = {
      subscriptionID: subscriptionID,
      newWorkflowMode: newWorkflowMode
    };

    const preupdatedData = allKeys.find(
      item => item._id === currentSubscriptionId
    );

    //console.log("[DEBUG] preupdatedData", preupdatedData);

    const res2 = await post("/kiosk/updateAllWorkflow", payload);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      //SInce format can change, just reload from server
      await refreshKioskList();
      //Lets just try updating just that view
      await refreshViewKiosksList();
      await setKioskListForceRefreshToggle(!kioskListForceRefreshToggle);

      await loadDetails(currentSubscriptionId);

      // TODO: Currently some issues with refreshing the KioskListDialog immediately, so force closing the dialog for now.
      setShowKiosksListDialog(false);
      openSnackbar({
        open: true,
        message: "RELOADED!",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });

      const updatedData = allKeys.find(
        item => item._id === currentSubscriptionId
      );

      //console.log("[DEBUG] updatedData", updatedData);

      //Since we moved the dialog inside the display List, the following will update the list  //This part seems to have an error?
      await setKiosklistKiosk(updatedData);

      //Either update data or repull from server
      return subscriptionData;
    }
  };

  const handleDebugAlert = async (subscriptionID, newWorkflowMode) => {
    //Doesn't seem like this is used.....
    openSnackbar({
      open: true,
      message: "handleDebugAlert",
      variant: "alert",
      alert: {
        color: "error"
      },
      close: false
    });
    return;
  };

  const handleActionSetMode = id => {
    setAllWorkflowSubscription(allKeys.find(item => item._id === id));
    setShowSetAllWorkflowDialog(true);
  };

  const handleActionClearError = async id => {
    let payload = {
      id: id
    };

    //console.log("handleActionClearError payload id", payload, id);

    const res2 = await post("/kiosk/clearSubscriptionError/", payload);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      //Since format can change, just reload from server
      await refreshKioskList();
    }
  };

  //////// Sync Functions /////////

  const handleActionCollectorSync = async id => {
    setCollectorSyncTarget(id);
    setShowCollectorSyncDialog(true);
  };

  const performActionCollectorSync = async id => {
    let payload = {
      id: collectorSyncTarget.id,
      code: collectorSyncTarget.locationCode,
      technologyID: collectorSyncTarget.technologyID
    };

    //console.log("performActionCollectorSync payload id", payload, id);

    const res2 = await post("/kiosk/syncTechnology/", payload);

    //console.log("performActionCollectorSync res2", res2);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to save changes.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      setShowCollectorSyncDialog(false);
      await refreshKioskList();
      return;
    }

    openSnackbar({
      open: true,
      message: "Changes saved successfully!",
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });

    setShowCollectorSyncDialog(false);
    await refreshKioskList();
  };

  const performActionGlobalCollectorSync = async () => {
    setShowFullSyncDialog(false);
    setLoading(true); //loadKeys will set loading to false;
    const res2 = await post("/kiosk/syncAllTechnologies/");

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to save changes.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      setLoading(false);
      return;
    }

    openSnackbar({
      open: true,
      message: "Changes saved successfully!",
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });

    await refreshKioskList();
  };

  useEffect(() => {
    (async () => {
      //await getDropLocations();
      await refreshKioskList();
    })();
  }, []);

  //So that we can filter out used dropLocations
  useEffect(() => {
    (async () => {
      await getDropLocations();
    })();
  }, [allKeys]);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: theme.spacing(2)
          }}
        >
          <Typography variant="h4">Kiosks</Typography>
          <Typography variant="h5" style={{ marginLeft: theme.spacing(2) }}>
            <span style={{ color: "grey" }}>
              ({allKeys.length} result{allKeys.length == 1 ? "" : "s"}
              {!showDisabledEntries && numHiddenKeys > 0
                ? ", " + numHiddenKeys + " hidden"
                : ""}
              )
            </span>
          </Typography>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: theme.spacing(1)
          }}
        >
          <ContainerLoading show={loading} />
          <Button
            variant="outline"
            onClick={() => {
              setShowDisabledEntries(!showDisabledEntries);
            }}
            disabled={loading}
          >
            <VisibilityIcon
              visible={showDisabledEntries}
              style={{ marginRight: theme.spacing(1) }}
            />
            {showDisabledEntries ? "Hide" : "Include"} Disabled
          </Button>
          <Button
            variant="contained"
            onClick={() => setShowCreateKeyDialog(true)}
            disabled={loading}
          >
            <Add style={{ marginRight: theme.spacing(1) }} />
            Add Kiosk Location
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={() => setShowFullSyncDialog(true)}
            disabled={loading}
          >
            <SyncIcon style={{ marginRight: theme.spacing(1) }} />
            Full Sync
          </Button>
        </div>
        <div></div>
      </div>
      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      {/* <ContainerLoading show={loading} /> */}
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Web Client</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Collector Code</TableCell>
              <TableCell align="left">Kiosk Key</TableCell>

              <TableCell align="left">Address</TableCell>

              <TableCell align="left">Last Updated</TableCell>

              <TableCell align="left">Default Mode</TableCell>
              <TableCell align="left">Modes</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allKeys.map(row => (
              <KioskRow
                row={row}
                showDisabledEntries={showDisabledEntries}
                handleActionViewKiosks={handleActionViewKiosks}
                handleActionSetMode={handleActionSetMode}
                handleActionClearError={handleActionClearError}
                handleActionCollectorSync={handleActionCollectorSync}
                handleActionEdit={handleActionEdit}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddKioskLocationDialog
        open={showCreateKeyDialog}
        handleClose={() => setShowCreateKeyDialog(false)}
        locationOptions={locationOptions}
        locationList={locationList}
      />
      <KioskListDialog
        subscription={kiosklistKiosk}
        open={showKiosksListDialog}
        handleSetWorkflowModeKiosk={handleSetWorkflowModeKiosk}
        handleSetWorkflowModeSubscription={handleSetWorkflowModeSubscription}
        //handleSetWorkflowModeSubscription={handleDebugAlert}
        kioskListForceRefreshToggle={kioskListForceRefreshToggle}
        handleClose={() => setShowKiosksListDialog(false)}
      />

      <AlertDialog
        open={showFullSyncDialog}
        handleConfirm={performActionGlobalCollectorSync}
        handleClose={() => setShowFullSyncDialog(false)}
        title="Full Sync"
        confirmButtonName="Confirm"
        closeButtonName="Cancel"
      >
        <Typography style={{ marginBottom: theme.spacing(2) }}>
          Are you sure you would like to perform a full sync on all the
          collectors?
        </Typography>
      </AlertDialog>
      <AlertDialog
        open={showCollectorSyncDialog}
        handleConfirm={performActionCollectorSync}
        handleClose={() => setShowCollectorSyncDialog(false)}
        title="Collector Sync"
        confirmButtonName="Confirm"
        closeButtonName="Cancel"
      >
        <Typography style={{ marginBottom: theme.spacing(2) }}>
          Are you sure you would like to perform a sync on{" "}
          {collectorSyncTarget.locationCode
            ? collectorSyncTarget.locationCode
            : ""}
          ?
        </Typography>
      </AlertDialog>
      <KioskEditDialog
        subscription={kioskEditKiosk}
        open={showKioskEditDialog}
        handleSaveEditChanges={handleSaveEditChanges}
        handleClose={() => setShowKioskEditDialog(false)}
        newlocationOptions={locationOptions}
        newlocationList={locationList}
        locationsLoading={locationsLoading}
        //locationsRefreshFunc={getDropLocations}
      />
    </Grid>
  );
}

export default Kiosks;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
